// extracted by mini-css-extract-plugin
export default {"dropdowns-container":"dropdowncontainer_dropdowns-container__iI+kX","wrapper":"dropdowncontainer_wrapper__8UokN"};